package com.wintermar.inspection.feature.util.expect_init

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.TextTitleS
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
actual fun LandingHeader(title: String) {
    val color = LocalAppTheme.current.color
    val dimension = LocalAppTheme.current.dimension

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(color.surface.normal)
    ) {
        TextTitleS(
            text = title,
            bold = true,
            modifier = Modifier.padding(
                vertical = dimension.spacing.space4,
                horizontal = dimension.spacing.space5)
        )
        HorizontalDivider(
            modifier = Modifier.fillMaxWidth().height(1.dp),
            color = color.border.subtle
        )
    }
}
